import {css} from "@emotion/react";
import React from 'react';
import {useCreateCallLogs, useDeleteCallLogs, useUpdateCallLogs} from "../../../../sdk/mutations";
import {useTrainById} from "../../../../sdk/queries";
import {Button} from '../../../Button';
import {Modal, ModalProps} from "../../../Modal";
import {columnModal, LineMark, rowModal} from "../../styles";
//import {DataAction} from "../800CallLogsProvider";
import {MapRow} from "../MapRow";
import {SimpleRow, SimpleRowEditProps} from "../SimpleRow";
import {TextAreaModal} from "../TextAreaModal";
import {
    bigError,
    editDeleteContainer,
    errorSpan,
    graphCaret,
    graphFigure,
    graphImage,
    graphMissing,
    graphPanel,
    graphToggle,
} from "./styles";
import moment from "moment";
import {AQICode} from "./components/AQICode";
import {useAuth} from "../../../Auth";


export type ModalTrainProps = {
    mode?: "view";
    modalProps: ModalProps;
    callLogId?: number | null;
    locationId?: number | null;
}

//const editOrCreate: Array<NonNullable<Modal800CallLogsProps['mode']>> = ["edit", "create"];
const view: Array<NonNullable<ModalTrainProps['mode']>> = ["view"];
//export type CallLogsInputsData = Partial<{
//    calledDate: string;
//    callTime: string;
//    callerName: string;
//    callerPhone: string;
//    callerText: string;
//    actionsTaken: string;

    //Address data
//    callerZip: string;
//    callerState: string;
//    callerCity: string;
//    callerAddress: string;
//}>

const timeToMoment = (input: string) => {
    return moment(input.replace(/(( hours, )|( minutes and )|( seconds))/g, ":"),"HH:mm:ss:",true);
}

// Widened only when this train actually has graphs to show, so the modal pops
// wider as a cue that they are available and non-admins never get a wide modal
// full of empty space. Capped against the viewport so it cannot overflow on a
// laptop screen; Modal falls back to its default 1200px when width is
// undefined. The graphs render around 1586px natively.
const GRAPH_MODAL_WIDTH = "min(1600px, calc(100vw - 96px))";

// One RAM dust sensor graph. The api hands back a base64 png data url, so it
// goes straight into an <img> with no blob or object url juggling, and no
// second request.
// No visible caption -- the graph metadata callout above already identifies
// them. label survives only as the img alt text, and to name the sensor in
// the message shown when a graph is missing.
const TrainGraph: React.FC<{label: string; src?: string | null}> = ({label, src}) => (
    <figure css={graphFigure}>
        {src
            ? <img css={graphImage} src={src} alt={`${label} dust sensor graph`}/>
            : <span css={graphMissing}>No {label} graph recorded for this train.</span>}
    </figure>
);

export const ModalTrains: React.FC<ModalTrainProps> = ({
    mode = "view",
    modalProps,
    callLogId,
    locationId
}) => {

    const {userRole} = useAuth()
  
    const isEditOrView = view.includes(mode);

    const [submitLoading, setSubmitLoading] = React.useState<boolean>(false);

//    React.useLayoutEffect(() => {
//        setData({});
//        setSubmitLoading(false);
//    }, [modalProps.open]);

//    const [data, setData] = React.useState<CallLogsInputsData>({});

    const [error, setError] = React.useState({errorState: "", errorTime: "", errorDate: "", errorFlag: 0});

    // Collapsed by default. Reset whenever the modal opens on another train so
    // it never opens already expanded from a previous look.
    const [graphsOpen, setGraphsOpen] = React.useState<boolean>(false);

    const strCallLogId = callLogId !== null && callLogId !== undefined ? String(callLogId) : "";

    const strLocationId = locationId !== null && locationId !== undefined ? String(locationId) : "";

    const {data, loading} = useTrainById({
        //skip: !modalProps.open || !view || !strCallLogId,
        variables: {
            id: strCallLogId,
	    location_id: strLocationId
        },
        cachePolicy: "no-cache",
    });

    const train = data?.data

    const hasGraphs = Boolean(train?.ram_1_graph || train?.ram_2_graph);

    // Only admins ever see the graphs, so only their modal widens.
    const showGraphs = hasGraphs && userRole === "admin";

    React.useEffect(() => {
        setGraphsOpen(false);
    }, [modalProps.open, strCallLogId, strLocationId]);

//    React.useLayoutEffect(() => {
//        if (isEditOrView) {
//            if (!trainByIdLoading) {
//                const _data = trainByIdData?.data;
//                setData({
//                    calledDate: _data?.start_at?.split("T")[0],
//                })
//            }
//        }
//    }, [trainByIdData, trainByIdLoading]);


    const isGettingData = false;//trainByIdLoading && isEditOrView;

    //const [createCallLog, {data: createCallLogData, loading: createCallLogLoading}] = useCreateCallLogs();
    //const [updateCallLog, {data: updateCallLogData, loading: updateCallLogLoading}] = useUpdateCallLogs();
    //const [deleteCallLog, {data: deleteCallLogData, loading: deleteCallLogLoading}] = useDeleteCallLogs();


//    const _onDataChange = (name: string, value: string) => {
//        setData(prev => ({...prev, [name]: value}));
//    }

//    interface errorTypes {
//        errorState: string,
//        errorTime: string,
//        errorDate: string,
//        errorFlag: number
//    }

//    const handleValidation = () => {
//        let formIsValid = true;
//        let obj: errorTypes = {errorState: "", errorTime: "", errorDate: "", errorFlag: 0};

//        if(!data.callerState){
    //         formIsValid = false;
    //         obj["errorState"] = "*Required";
    //         obj["errorFlag"] = 1;
    //     }

    //     if(!data.calledDate){
    //         formIsValid = false;
    //         obj["errorDate"] = "*Required";
    //         obj["errorFlag"] = 1;
    //     }

    //     if(!data.callTime){
    //         formIsValid = false;
    //         obj["errorTime"] = "*Required";
    //         obj["errorFlag"] = 1;
    //     }
    //     console.log(data?.callTime)
    //     if(!moment(data?.callTime,"HH:mm:ss").isValid()){
    //         formIsValid =  false;
    //         obj["errorTime"] = "*Invalid time format";
    //         obj["errorFlag"] = 1;
    //     }

    //     setError(obj);
    //     console.log(obj);
    //     return formIsValid;
    // }




//    const onSubmit = () => {
//        setSubmitLoading(true);
        // Choose whether to use edit or create mutation

//        const chosenMutation = mode === "edit" ? updateCallLog : createCallLog;
//        chosenMutation({
//            data: {
//                actionsTaken: data.actionsTaken || "",
//                calledAt: data.calledDate + " " + data.callTime || "",
//                callerAddress: data.callerAddress || "",
//                callerCity: data.callerCity || "",
//               callerName: data.callerName || "",
//                callerPhone: data.callerPhone || "",
//                callerState: data.callerState || "",
//                callerText: data.callerText || "",
//                callerZip: data.callerZip || "",
//            },
//            variables: mode === "edit" ? {
//                id: String(callLogId),
//            } : undefined,
//        }).then(x => {
//            setSubmitLoading(false);
//            const id = x?.data?.id ?? null;
//            if (id !== null) {
//                console.debug("CREATED", id);
//                onModify?.(id, "create");
//                modalProps.onClose?.();
//            }
//        });
//    };

    return (
      <Modal title="Train Details"
             {...modalProps}
             width={showGraphs ? GRAPH_MODAL_WIDTH : undefined}>
        <div>
          <div css={columnModal}>
            {
              isGettingData ? (
                "Getting details..."
              ) : (
                <React.Fragment>
                  <div css={rowModal} style={{display:"flex",alignContent:"center"}}>

                    <SimpleRow fullWidth={false}
		               label={"ID"}
                               multiRow={true}
			       value={train?.name}/>
                    <LineMark/>

                    <SimpleRow fullWidth={false} multiRow={true} variant = "time" 
			       label={"Pass Date/Time"} value={moment(train?.start_at).format("MM-DD-yyyy HH:mm")}/>
                    <LineMark/>
                    <SimpleRow fullWidth={false} multiRow={true} 
		               label={"Associated Mines"}
			       value={train?.associated_mines}/>
                    <LineMark/>
                    <SimpleRow fullWidth={false} multiRow={true} 
		               label={"STCC"}
			       value={train?.stcc_codes}/>
                    <LineMark/>
                    <SimpleRow fullWidth={false} multiRow={true} 
		               label={"Coal Car Count"}
			       value={train?.coal_car_count}/>
		    <LineMark/>
		    <SimpleRow fullWidth={false} multiRow={true}
			       label={"Car Count - Loaded, Empty"}
			       value={train?.loaded_car_count + "," + train?.empty_car_count}/>
		    <LineMark/>
                    <SimpleRow fullWidth={false} multiRow={true} 
		               label={"Speed (mph)"}
			       value={train?.avg_speed != null ? train?.avg_speed : "--"}/>
		    <LineMark/>
		    {userRole === "admin"  && (
		      <>
                    <SimpleRow fullWidth={false} multiRow={true}
		               label={hasGraphs ? (
		                 <button type="button"
		                         css={graphToggle}
		                         aria-expanded={graphsOpen}
		                         aria-controls="train-ram-graphs"
		                         title={graphsOpen ? "Hide RAM graphs" : "Show RAM graphs"}
		                         onClick={() => setGraphsOpen(open => !open)}>
		                   <span css={graphCaret} aria-hidden={true}>{graphsOpen ? "▾" : "▸"}</span>
		                   IDV (du)
		                 </button>
		               ) : "IDV (du)"}
			       value={train?.idv != null ? train?.idv : "--"}/>

		    {hasGraphs && graphsOpen && (
		      <div css={graphPanel} id="train-ram-graphs">
		        <TrainGraph label="ram_1" src={train?.ram_1_graph}/>
		        <TrainGraph label="ram_2" src={train?.ram_2_graph}/>
		      </div>
		    )}

		    <LineMark />
		      </>
		    )}
                    <SimpleRow fullWidth={false} multiRow={true} 
		               label={"Dusting Category"}
			       value={<AQICode value={train?.cat ?? 0}/>}/>

                  </div>
                </React.Fragment>
              )
            }

          </div>
        </div>
      </Modal>
    );
};
